/* eslint-disable quote-props */
import { SxProps } from "@mui/material";
import { defaultTheme } from "../../styles/muiTheme";

export const boxStyle: SxProps = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "#F9F6F4",
  boxShadow: 24,
  borderRadius: "20px",
  outline: "none",
  // overflow: "hidden", // this we can remove for blurness
};

export const boxStyleInner: SxProps = {
  // padding: "30px 32px 26px",
  // maxHeight: "98vh",
  height: "fit-content",
  overflowY: "hidden", // this we can remove for blurness
  "&::-webkit-scrollbar": {
    width: 0,
  },
  "scrollBehavior": "smooth",
};

export const iconButtonStyle: SxProps = {
  position: "absolute" as "absolute",
  top: "40px",
  left: "24px",
  color: defaultTheme.palette.taupe.main,
  "& svg": {
    fontSize: 18,
    color: "#262626",
  },
};

